import React, { memo, useContext } from 'react';
import { RatingStars } from '../RatingStars';
import { Margin, Anchor } from '../../atoms';
import { NoReviewStyled, ColumnWrapper } from './Styled';

import { context } from '../../../context';

const NoneReview = () => {
  const { config } = useContext(context);
  const { productId } = config;
  const href = `/avaliacao/${productId}`;

  return (
    <NoReviewStyled>
      <ColumnWrapper>
        <div>
          <RatingStars size={26} rating={0} />
          <Margin top={5} bottom={5} />
          <p>Ajude outras pessoas,</p>
          <b>faça a primeira avaliação desse produto ;)</b>
        </div>
        <div>
          <Anchor href={href}>avaliar produto</Anchor>
        </div>
      </ColumnWrapper>
    </NoReviewStyled>
  );
};

const NoReview = memo(NoneReview);

export default NoReview;
export { NoReview };
